import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { TruckloadDialog } from 'src/modules/supply_chain/components/freight/TruckloadDialog'
import { skuit } from 'src/services/skuit'

import { TruckloadListTable } from 'src/components/Table/list/Truckload'
import { ListPage } from 'src/components/Pages/ListPage'

export const TruckloadListPage = () => {
  const paginator = useQueryPaginator('truckload-list', skuit.sc.freight.truckloads.list)

  const exportFields = [
    'bill_of_lading_number',
    'carrier_guid',
    'carrier_name',
    'client_guid',
    'client_name',
    'facility_address',
    'facility_guid',
    'facility_name',
    'guid',
    'loaded_on',
    'name',
    'path',
    'place_guid',
    'shipped_on',
    'status',
    'tracking_number',
    'trailer_number',
  ]

  return (
    <ListPage
      title='Truckloads'
      paginator={paginator}
      dialogs={[{ title: 'New Truckload', Dialog: TruckloadDialog }]}
    >
      <TruckloadListTable
        paginator={paginator}
        fields={['trackingNumber', 'billOfLadingNumber', 'trailerNumber', 'client', 'facility', 'carrier', 'status', 'numOrders', 'appointment']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.freight.truckloads.export
        }}
      />
    </ListPage>
  )
}
